export default "__VITE_ASSET__BYJqdgNx__"